import { render, staticRenderFns } from "./CreatePlayer.vue?vue&type=template&id=3242744a&"
import script from "./CreatePlayer.vue?vue&type=script&lang=js&"
export * from "./CreatePlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports